import { render, staticRenderFns } from "./AuditoriaAulas.vue?vue&type=template&id=49f188c6"
import script from "./AuditoriaAulas.vue?vue&type=script&lang=js"
export * from "./AuditoriaAulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports